import { Component, OnInit } from '@angular/core';
import { UtilityProvider } from 'app/providers/utility/utility';
import { DataManagement } from 'app/services/dataManagement';
import { RestWS } from 'app/services/restService';
import { GlobalService } from 'app/services/globalService';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-opciones',
  templateUrl: './opciones.component.html',
  styleUrls: ['./opciones.component.scss']
})
export class OpcionesComponent implements OnInit {

  loading: boolean = false;
  muestraPrompt: boolean = false;
  muestraDiscador: boolean = false;
  prompt: string = '';
  muestraTipificaciones: boolean = false;
  muestraVoces: boolean = false;
  muestraSaludo: boolean = false;
  vozActual: string = 'UOIqAnmS11Reiei1Ytkc'; // Carolina
  textoIa: string = '';
  textoBoton: string = 'Generar Voz';
  muestraObjetivos: boolean = false;
  muestraEmail: boolean = false;
  email: string;
  passUnlock: string;
  showPass: boolean = false;
  discadorActivo: boolean = false;
  existDiscador: boolean = true;
  leadsProcesados: any;
  leadsPendientes: any;
  numeroLeads: any;
  tipoPlantilla: number = 0;
  plantillas: any = ['Encuestas', 'Gestión de Citas', 'Atención Cliente y Transferencia Llamadas', 'Atención Telefónica', 'Asistente a Mayores'];
  muestraSms: boolean = false;
  sms: string;
  muestraOpcionesSms: boolean = false;
  tipificacionActual: any;
  muestraEnviar: boolean;
  
  async showUnlock() {
    let tag: any = document.getElementById('unlockPass') as HTMLInputElement;
    if (tag.value.trim() !== '') {
      let pass: any = await this.api.unlock(tag.value);
      this.showPass = (pass.status === 'bad');
      if (this.showPass) {
        tag.value = '';
        tag.placeholder = 'Contraseña incorrecta';
      } else {
        this.globalService.Admin = true;
      }
    } else {
      this.showPass = true;
      this.muestraPrompt = false;
    }
  }

  subidaModelo() {
    this.utils.openDialog("Función no disponible.", "Contacte con ventas", false, false);
  }

  async makeVoice() {
    this.loading = true;
    this.textoBoton = 'Generando voz...'
    let text = (document.getElementById("textoIa") as HTMLTextAreaElement);
    this.textoIa = text.value;
    let voz = await this.dm.makeVoice(this.vozActual, this.textoIa);
    console.log(voz);
    if (voz.status === 'ok') {
      let audio = document.getElementById('miaudio') as HTMLAudioElement;
      audio.src = 'data:audio/mpeg;base64,' + voz.message;
      this.loading = false;
      audio.play();
      this.textoBoton = 'Generar Voz';
    } else {
        this.loading = false;
        this.textoBoton = 'Generar Voz';
        this.utils.openDialog("No ha podido reproducir voz.", "Inténtelo de nuevo.", false, false);
    }
  }

  async saveVoice() {
    this.globalService.campaignAivoz.voz = this.vozActual;
    this.globalService.campaignAivoz.comando = null;
    let voz:any = await this.api.updateAivozCampaign(this.globalService.campaignAivoz);
    this.utils.openDialog("Voz actualizada.", "Cambios realizados correctamente", false, false);

  }

  clickEnviar() {
    let enviarSms = document.getElementById('enviarSms') as HTMLInputElement;
    this.tipificacionActual.enviarSms = enviarSms.checked;
  }

  async makePlantilla() {
    if (this.globalService.checkService('plantilla')) {
      if (this.tipoPlantilla !== this.globalService.campaignAivoz.tipo) {
          let confirm = await this.utils.openDialog('Plantilla', 'Si cambia plantilla, borrará los datos actuales. ¿ Cambiar a Plantilla ' + this.plantillas[this.tipoPlantilla - 1] + ' ?', true, true);
          if (confirm) {
            this.globalService.campaignAivoz.tipo = this.tipoPlantilla;
            this.globalService.campaignAivoz.datosIa = [];
            this.globalService.campaignAivoz.calendario = {
              intervalo: 30,
              dias: '',
              horaInicio: '00:00',
              horaFin: '00:00',
              activo: false,
              reservas: [],
              nombre: 'Mi Calendario'
            }
            await this.api.updateAivozCampaign(this.globalService.campaignAivoz);
            this.mostrarPrompt();
            this.utils.openDialog('Plantilla', 'Ha cambiado a la plantilla: ' + this.plantillas[this.tipoPlantilla - 1], false, false);
          } else {
          }
      } else {
        this.utils.openDialog('Plantilla', 'La plantilla seleccionada es la actual. No se realizan cambios.', false, false);
      }
    } else {
      this.utils.openDialog('Plantilla', 'No tiene permisos para cambiar plantilla.', false, false);
    }
  }

  async cambiaPlantilla() {
    let data = document.getElementById('plantilla') as HTMLSelectElement;
    let tipoPlantilla = Number(data.value);
    if (this.globalService.checkService('plantilla')) {
      if (tipoPlantilla < 1 || tipoPlantilla > 5) {
        this.utils.openDialog('Plantilla', 'Plantilla no activa', false, false);
        data.value = this.tipoPlantilla.toString();
      } else {
        this.tipoPlantilla = tipoPlantilla;
      }
    } else {
      data.value = this.tipoPlantilla.toString();
      this.utils.openDialog('Permisos', 'No tiene permisos de acceso a esta opción', false, false);
    }
  }

  async makeTipo1() {
    let dt1: any; 
    let dt2: any; 
    let dt3: any;
    let dt4: any;
    this.loading = true;
    dt1 = document.getElementById('datos1') as HTMLAreaElement;
    dt2 = document.getElementById('datos2') as HTMLAreaElement;
    dt3 = document.getElementById('datos3') as HTMLAreaElement;
    dt4 = document.getElementById('datos4') as HTMLAreaElement;
    dt1.value = dt1.value.toString().replaceAll('\n', ' ');
    dt2.value = dt2.value.toString().replaceAll('\n', ' ');
    dt3.value = dt3.value.toString().replaceAll('\n', ' ');
    dt4.value = dt4.value.toString().replaceAll('\n', ' ');
    let myPrompt = 'Eres un experto en hacer encuestas. La encuesta la solicita ' + dt1.value + '.Tienes que hacer las siguientes preguntas en la encuesta: ' + dt3.value + '. Haz una pregunta y no pases a la siguiente hasta que responda la actual. Para calificar las respuestas básate en esta petición: ' + dt2.value + ' . Otro datos a conocer son los siguientes ' + dt4.value + '. Usa siempre FRASES MUY CORTAS y focaliza solo el objetivo. Haz la conversación lo más corta posible con preguntas cortas y concisas. Cuando hayas definido el objetivo despídete de forma correcta y di TERMINA LLAMADA.' 
    this.globalService.campaignAivoz.datosIa = [];
    this.globalService.campaignAivoz.datosIa.push(dt1.value);
    this.globalService.campaignAivoz.datosIa.push(dt2.value);
    this.globalService.campaignAivoz.datosIa.push(dt3.value);
    this.globalService.campaignAivoz.datosIa.push(dt4.value);
    this.globalService.campaignAivoz.tipo = 1;
    this.globalService.campaignAivoz.prompt = myPrompt; //ia.choices[0].message.content;
    let prompt:any = await this.api.updateAivozCampaign(this.globalService.campaignAivoz);
    console.log('prompt: ', prompt);
    this.loading = false;
    this.utils.openDialog("IA generada.", "Cambios realizados correctamente", false, false);

  }
  async makeTipo3() {
    let dt1: any; 
    let dt2: any; 
    let dt3: any;
    let dt4: any;
    this.loading = true;
    dt1 = document.getElementById('datos1') as HTMLAreaElement;
    dt2 = document.getElementById('datos2') as HTMLAreaElement;
    dt3 = document.getElementById('datos3') as HTMLAreaElement;
    dt4 = document.getElementById('datos4') as HTMLAreaElement;
    dt1.value = dt1.value.toString().replaceAll('\n', ' ');
    dt2.value = dt2.value.toString().replaceAll('\n', ' ');
    dt3.value = dt3.value.toString().replaceAll('\n', ' ');
    dt4.value = dt4.value.toString().replaceAll('\n', ' ');
    //let myPrompt = 'Eres un agente telefónico encargado de transferir llamadas entrantes. La empresa que se dedica a ' + dt1.value + '. La empresa tiene los siguientes departamentos:  ' + dt2.value + ' . Además los departamentos tienen las siguientes numeraciones telefónicas: ' + dt3.value  +'. Tienes que tener en cuenta también los siguientes supuestos: ' + dt4.value + '. Usa siempre FRASES MUY CORTAS y focaliza solo el objetivo de saber con cual departamento quiere contactar el usuario. Haz la conversación lo más corta posible con preguntas cortas y concisas. Cuando hayas encontrado el departamento o el usuario no especifica el departamento, escribe el departamento entre (), el numero de teléfono correspondiente al departamento entre {} y di  [TRANSFERIRLLAMADA]. En el caso de que no puedas transferir por cualquier motivo despídete amablemente y di [TERMINARLLAMADA]' 
    this.globalService.campaignAivoz.datosIa = [];
    this.globalService.campaignAivoz.datosIa.push(dt1.value);
    this.globalService.campaignAivoz.datosIa.push(dt2.value);
    this.globalService.campaignAivoz.datosIa.push(dt3.value);
    this.globalService.campaignAivoz.datosIa.push(dt4.value);
    this.globalService.campaignAivoz.tipo = 3;
    //this.globalService.campaignAivoz.prompt = myPrompt; //ia.choices[0].message.content;
    let prompt:any = await this.api.updateAivozCampaign(this.globalService.campaignAivoz);
    console.log('prompt: ', prompt);
    this.loading = false;
    this.utils.openDialog("IA generada.", "Cambios realizados correctamente", false, false);

  }

  async makeTipo4() {
    let dt1: any; 
    let dt2: any; 
    let dt3: any;
    let dt4: any;
    this.loading = true;
    dt1 = document.getElementById('datos1') as HTMLAreaElement;
    dt2 = document.getElementById('datos2') as HTMLAreaElement;
    dt3 = document.getElementById('datos3') as HTMLAreaElement;
    dt4 = document.getElementById('datos4') as HTMLAreaElement;
    dt1.value = dt1.value.toString().replaceAll('\n', ' ');
    dt2.value = dt2.value.toString().replaceAll('\n', ' ');
    dt3.value = dt3.value.toString().replaceAll('\n', ' ');
    dt4.value = dt4.value.toString().replaceAll('\n', ' ');
    let myPrompt = dt1.value + '.Tienes que ' + dt2.value + ' .El usuario final al que va dirigida la conversación es ' + dt3.value  +' . Otro datos a conocer son los siguientes ' + dt4.value + '. Usa siempre FRASES MUY CORTAS y focaliza solo el objetivo. Haz la conversación lo más corta posible con preguntas cortas y concisas. Cuando hayas definido el objetivo despídete de forma correcta y di TERMINA LLAMADA.' 
    this.globalService.campaignAivoz.datosIa = [];
    this.globalService.campaignAivoz.datosIa.push(dt1.value);
    this.globalService.campaignAivoz.datosIa.push(dt2.value);
    this.globalService.campaignAivoz.datosIa.push(dt3.value);
    this.globalService.campaignAivoz.datosIa.push(dt4.value);
    this.globalService.campaignAivoz.tipo = 4;
    this.globalService.campaignAivoz.prompt = myPrompt; //ia.choices[0].message.content;
    let prompt:any = await this.api.updateAivozCampaign(this.globalService.campaignAivoz);
    console.log('prompt: ', prompt);
    this.loading = false;
    this.utils.openDialog("IA generada.", "Cambios realizados correctamente", false, false);

  }

  async makeTipo5() {
    let dt1: any; 
    let dt2: any; 
    let dt3: any;
    let dt4: any;
    this.loading = true;
    dt1 = document.getElementById('datos1') as HTMLAreaElement;
    dt2 = document.getElementById('datos2') as HTMLAreaElement;
    dt3 = document.getElementById('datos3') as HTMLAreaElement;
    dt4 = document.getElementById('datos4') as HTMLAreaElement;
    dt1.value = dt1.value.toString().replaceAll('\n', ' ');
    dt2.value = dt2.value.toString().replaceAll('\n', ' ');
    dt3.value = dt3.value.toString().replaceAll('\n', ' ');
    dt4.value = dt4.value.toString().replaceAll('\n', ' ');
    let myPrompt = dt1.value + '.Tienes que ' + dt2.value + ' .El usuario final al que va dirigida la conversación es ' + dt3.value  +' . Otro datos a conocer son los siguientes ' + dt4.value + '. Usa siempre FRASES MUY CORTAS y focaliza solo el objetivo. Haz la conversación lo más corta posible con preguntas cortas y concisas. Cuando hayas definido el objetivo despídete de forma correcta y di TERMINA LLAMADA.' 
    this.globalService.campaignAivoz.datosIa = [];
    this.globalService.campaignAivoz.datosIa.push(dt1.value);
    this.globalService.campaignAivoz.datosIa.push(dt2.value);
    this.globalService.campaignAivoz.datosIa.push(dt3.value);
    this.globalService.campaignAivoz.datosIa.push(dt4.value);
    this.globalService.campaignAivoz.tipo = 5;
    //this.globalService.campaignAivoz.prompt = myPrompt; //ia.choices[0].message.content;
    let prompt:any = await this.api.updateAivozCampaign(this.globalService.campaignAivoz);
    console.log('prompt: ', prompt);
    this.loading = false;
    this.utils.openDialog("IA generada.", "Cambios realizados correctamente", false, false);

  }

  async makePrompt() {
    if (this.globalService.campaignAivoz.tipo == 1) 
      this.makeTipo1()
    else if (this.globalService.campaignAivoz.tipo == 2)
      this.makeTipo2()
    else if (this.globalService.campaignAivoz.tipo == 3)
        this.makeTipo3()
    else if (this.globalService.campaignAivoz.tipo == 4)
      this.makeTipo4()
    else if (this.globalService.campaignAivoz.tipo == 5)
      this.makeTipo5()
    else this.makeTipo4();
  }
  
  async makeTipo2() {
    let dt1: any; 
    let dt2: any; 
    this.loading = true;
    dt1 = (document.getElementById('datos1') as HTMLAreaElement);
    dt2 = document.getElementById('datos2') as HTMLAreaElement;
    dt1.value = dt1.value.toString().replaceAll('\n', ' ');
    dt2.value = dt2.value.toString().replaceAll('\n', ' ');
    this.globalService.campaignAivoz.datosIa = [];
    this.globalService.campaignAivoz.datosIa.push(dt1.value);
    this.globalService.campaignAivoz.datosIa.push(dt2.value);
      let dias = '';
      for (var i = 0; i < 7; i++) {
        let dia = document.getElementById('d' + i.toString()) as HTMLInputElement;
        if (dia.checked) {
          dias = dias + i.toString();
        }
      }
      this.globalService.campaignAivoz.calendario.tipo = 2;
      this.globalService.campaignAivoz.calendario.activo = true;
      this.globalService.campaignAivoz.calendario.dias = dias;
      this.globalService.campaignAivoz.calendario.nombre = dt1.value;;

      let inicio = document.getElementById('inicio') as HTMLInputElement;
      console.log(inicio.value);
      let fin = document.getElementById('fin') as HTMLInputElement;
      console.log(fin.value);
      let intervalo = document.getElementById('intervalo') as HTMLInputElement;
      this.globalService.campaignAivoz.calendario.horaInicio = inicio.value;
      this.globalService.campaignAivoz.calendario.horaFin = fin.value;
      if (Number(intervalo.value) < 5) {
        this.utils.openDialog('Atención', 'Intervalo no admitido. El mínimo debe ser 5 minutos', true, true);
      } else {
        this.globalService.campaignAivoz.calendario.intervalo = Number(intervalo.value);
        let campaign:any = await this.api.updateAivozCampaign(this.globalService.campaignAivoz);
        let prompt:any = await this.api.updateCalendar(this.globalService.campaignAivoz);
        console.log('Campaign: ', campaign);
        this.utils.openDialog("IA generada.", "Cambios realizados correctamente", false, false);
      }
    this.loading = false;
  }

  async makeSaludo() {
    let tag: any = document.getElementById('saludo') as HTMLAreaElement;
    this.globalService.campaignAivoz.saludo = tag.value;
    this.globalService.campaignAivoz.aivozData = this.globalService.clienteAivoz;
    this.globalService.campaignAivoz.comando = 'saludo';
    let saludo:any = await this.api.updateAivozCampaign(this.globalService.campaignAivoz);
    this.utils.openDialog("Saludo actualizados.", "Cambios realizados correctamente", false, false);
  }

  async makeTipificaciones() {
    let tag: any = document.getElementById('tipificacion') as HTMLInputElement;
    if (tag.value.trim() !== '') {
      this.globalService.campaignAivoz.tipificaciones.push({ tipificacion: tag.value, enviarEmail: false });
      this.globalService.campaignAivoz.comando = null;
      let campaignAivoz:any = await this.api.updateAivozCampaign(this.globalService.campaignAivoz);
      this.globalService.campaignAivoz = campaignAivoz.message;
      this.utils.openDialog("Nuevas Tipificaciones establecidas.", "Cambios realizados correctamente", false, false);
      tag.value = '';
    }
  }

  async borrarTipificacion(tip) {
    let tips = this.globalService.campaignAivoz.tipificaciones;
    for (let i = 0; i<tips.length; i++) {
      if (tips[i] === tip) {
        tips.splice(i, 1);
        break;
      }
    }
    this.globalService.campaignAivoz.tipificaciones = tips;
    this.globalService.campaignAivoz.comando = null;
    let saludo:any = await this.api.updateAivozCampaign(this.globalService.campaignAivoz);
  }

  async makeEmail() {
    let tag: any = document.getElementById('email') as HTMLInputElement;
    let tagCheck: any = document.getElementById('checkEmail') as HTMLInputElement;
    if (tag.value.trim() !== '') {
      this.globalService.campaignAivoz.email = tag.value;
      this.globalService.campaignAivoz.emailActive = tagCheck.checked;
      this.globalService.campaignAivoz.comando = null;
      let saludo:any = await this.api.updateAivozCampaign(this.globalService.campaignAivoz);
      this.utils.openDialog("Configuración Envios Actualizada.", "Cambios realizados correctamente", false, false);
    }
  }

  async makeSms() {
    let tag: any = document.getElementById('sms') as HTMLInputElement;
    let tagCheck: any = document.getElementById('checkSms') as HTMLInputElement;
    if (tag.value.trim() !== '') {
      this.globalService.campaignAivoz.sms = tag.value;
      this.globalService.campaignAivoz.smsActive = tagCheck.checked;
      this.globalService.campaignAivoz.comando = null;
      let saludo:any = await this.api.updateAivozCampaign(this.globalService.campaignAivoz);
      this.utils.openDialog("Configuración Envios Actualizada.", "Cambios realizados correctamente", false, false);
    }
  }

  async makeObjetivos() {
    let tag: any = document.getElementById('objetivo') as HTMLInputElement;
    if (tag.value.trim() !== '') {
      this.globalService.campaignAivoz.objetivos.push(tag.value);
      this.globalService.campaignAivoz.comando = null;
      let saludo:any = await this.api.updateAivozCampaign(this.globalService.campaignAivoz);
      this.utils.openDialog("Nuevos Objetivos establecidos.", "Cambios realizados correctamente", false, false);
    }
  }

  async borrarObjetivo(obj) {
    let objs = this.globalService.campaignAivoz.objetivos;
    for (let i = 0; i<objs.length; i++) {
      if (objs[i] === obj) {
        objs.splice(i, 1);
        break;
      }
    }
    this.globalService.campaignAivoz.objetivos = objs;
    this.globalService.campaignAivoz.comando = null;
    let saludo:any = await this.api.updateAivozCampaign(this.globalService.campaignAivoz);
  }

  mostrarVoces() {
    if (this.globalService.checkService('voces')) {
      this.vozActual = this.globalService.campaignAivoz.voz;
      this.muestraVoces = true;
      this.textoIa = '';
      /*setTimeout(() => {
        let area = (document.getElementById("textoIa") as HTMLTextAreaElement);
        area.value = "";
        this.loading = false;
      }, 500)*/
    } else {
      this.utils.openDialog('Permisos', 'No tiene permisos de acceso a esta opción', false, true);
    }
    
  }

  mostrarEmail() {
    if (this.globalService.checkService('email')) {
    this.loading = true;
    this.muestraEmail = true;
    this.email = '';
    setTimeout(() => {
      let email = (document.getElementById("email") as HTMLInputElement);
      email.value = this.globalService.campaignAivoz.email;
      let check = (document.getElementById("checkEmail") as HTMLInputElement);
      check.checked = this.globalService.campaignAivoz.emailActive;
      this.loading = false;
    }, 500)
  } else {
    this.utils.openDialog('Permisos', 'No tiene permisos de acceso a esta opción', false, true);
  }
}

  mostrarSms() {
    if (this.globalService.checkService('sms')) {
    this.loading = true;
    this.muestraSms = true;
    this.sms = '';
    setTimeout(() => {
      let sms = (document.getElementById("sms") as HTMLInputElement);
      sms.value = this.globalService.campaignAivoz.sms ? this.globalService.campaignAivoz.sms : '';
      let check = (document.getElementById("checkSms") as HTMLInputElement);
      check.checked = this.globalService.campaignAivoz.smsActive;
      this.loading = false;
    }, 500)
  } else {
    this.utils.openDialog('Permisos', 'No tiene permisos de acceso a esta opción', false, true);
  }
    
    
  }

  mostrarPrompt() {
    if (this.globalService.checkService('ia')) {
    this.loading = true;
    this.muestraPrompt = true;
    this.prompt = '';
    setTimeout(() => {
      this.tipoPlantilla = this.globalService.campaignAivoz.tipo;
      let datosIa = this.globalService.campaignAivoz.datosIa;
      if (datosIa.length > 0) {
        let datos1 = (document.getElementById("datos1") as HTMLTextAreaElement);
        datos1.value = this.globalService.campaignAivoz.datosIa[0] ? this.globalService.campaignAivoz.datosIa[0] : '';
        let datos2 = (document.getElementById("datos2") as HTMLTextAreaElement);
        datos2.value = this.globalService.campaignAivoz.datosIa[1] ? this.globalService.campaignAivoz.datosIa[1] : '';
        if (this.globalService.campaignAivoz.tipo !== 2) {
          let datos3 = (document.getElementById("datos3") as HTMLTextAreaElement);
          datos3.value = this.globalService.campaignAivoz.datosIa[2] ?  this.globalService.campaignAivoz.datosIa[2] : '';
          let datos4 = (document.getElementById("datos4") as HTMLTextAreaElement);
          datos4.value = this.globalService.campaignAivoz.datosIa[3] ? this.globalService.campaignAivoz.datosIa[3] : '';
        } else if (this.globalService.campaignAivoz.tipo == 2) {
          (document.getElementById("intervalo") as HTMLInputElement).value = this.globalService.campaignAivoz.calendario.intervalo;
          let dias = this.globalService.campaignAivoz.calendario.dias;
          for (let i = 0; i < 6; i++) {
            if (dias.indexOf(i.toString()) > -1) {
              (document.getElementById('d' + i.toString()) as HTMLInputElement).checked = true; 
            }
          }
          (document.getElementById('inicio') as HTMLInputElement).value = this.globalService.campaignAivoz.calendario.horaInicio; 
          (document.getElementById('fin') as HTMLInputElement).value = this.globalService.campaignAivoz.calendario.horaFin; 


        }
      } else {
        (document.getElementById("datos1") as HTMLTextAreaElement).value = '';
        (document.getElementById("datos2") as HTMLTextAreaElement).value = '';
        if (this.globalService.campaignAivoz.tipo !== 2) {
          (document.getElementById("datos3") as HTMLTextAreaElement).value = '';
          (document.getElementById("datos4") as HTMLTextAreaElement).value = '';
        }

      }
      this.loading = false;
    }, 200)
  } else {
    this.utils.openDialog('Permisos', 'No tiene permisos de acceso a esta opción', false, true);

  }
    
  }

  async mostrarDiscador() {
    if (this.globalService.checkService('discador')) {
    this.loading = true;
    this.globalService.discador = await this.api.getDiscador({ idCampaign: this.globalService.campaignAivoz.idCampaign})
    this.existDiscador = this.globalService.discador;
    if (this.existDiscador) {
      this.discadorActivo = this.globalService.discador && this.globalService.discador.estado === 1;
      this.muestraDiscador = true;
      let usuarios:any = this.globalService.discador.usuarios;
      this.numeroLeads =  usuarios.length;
      this.leadsPendientes = usuarios.filter(user => user.estado === 0).length; 
      this.leadsProcesados = this.numeroLeads - this.leadsPendientes;
      console.log(this.numeroLeads, this.leadsPendientes, this.leadsProcesados);
        const element = document.getElementById('faq');
        if (element) element.scrollIntoView();

    }  else {
      this.muestraDiscador = true;
    }
    this.loading = false;
  } else {
    this.utils.openDialog('Permisos', 'No tiene permisos de acceso a esta opción', false, true);

  }
    
  }

  async discador(estado: number) {
    this.loading = true;
    let body = {
      idCampaign: this.globalService.campaignAivoz.idCampaign,
      estado: estado
    }
    this.globalService.discador = await this.api.lanzarDiscador(body);
    this.mostrarDiscador();
    this.loading = false;
  }

  mostrarTipificaciones() {
    if (this.globalService.checkService('tipificaciones')) {
    this.loading = true;
    this.muestraTipificaciones = true;
    this.prompt = '';
    this.loading = false;
    } else {
      this.utils.openDialog('Permisos', 'No tiene permisos de acceso a esta opción', false, true);

    }
  }

  mostrarObjetivos() {
    if (this.globalService.checkService('objetivos')) {
    this.loading = true;
    this.muestraObjetivos = true;
    this.prompt = '';
    this.loading = false;
    } else {
      this.utils.openDialog('Permisos', 'No tiene permisos de acceso a esta opción', false, true);

    }
  }

  cambiaTipoSms() {
    let tipoSms =  document.getElementById('tipoSms') as HTMLSelectElement;
    if (tipoSms.value == 'true') 
      this.tipificacionActual.sameSms = true
    else
      this.tipificacionActual.sameSms = false
  }

  async doActivarSms() {
    if (this.tipificacionActual.enviarSms) {
      if (!this.tipificacionActual.sameSms) {
        let numberSms = await document.getElementById('numberSms') as HTMLInputElement;
        this.tipificacionActual.numberSms = numberSms.value;
      }
      let textSms = await document.getElementById('textSms') as HTMLInputElement;
      this.tipificacionActual.textSms = textSms.value;
      for (let i = 0; i< this.globalService.campaignAivoz.tipificaciones.length; i++) {
        let tip = this.globalService.campaignAivoz.tipificaciones[i];
        if (this.tipificacionActual._id == tip._id) {
          this.globalService.campaignAivoz.tipificaciones[i] = this.tipificacionActual;
          break;
        }
      }
      console.log(this.globalService.campaignAivoz);
      this.globalService.campaignAivoz.comando = null;
      await this.api.updateAivozCampaign(this.globalService.campaignAivoz);
      this.muestraTipificaciones = true;
      this.muestraOpcionesSms = false;
    } else {
      
    }
      this.utils.openDialog("Tipificación actualizada", 'Opciones actualizadas' , false, false);

  }

  async activarSms(tipificacion) {
    this.tipificacionActual = tipificacion;
    console.log(this.tipificacionActual);
    this.muestraTipificaciones = false;
    this.muestraOpcionesSms = true;
    setTimeout(async () => {
        let enviarSms = await document.getElementById('enviarSms') as HTMLInputElement;
        enviarSms.checked = this.tipificacionActual.enviarSms;
        if (!this.tipificacionActual.sameSms) {  
          let numberSms = await document.getElementById('numberSms') as HTMLInputElement;
          numberSms.value = this.tipificacionActual.numberSms;
        }
        let textSms = await document.getElementById('textSms') as HTMLInputElement;
        textSms.value = this.tipificacionActual.textSms;
    }, 300);
   
  }

  async activarEmail(tipificacion) {
      console.log(tipificacion);
      for (let i = 0; i< this.globalService.campaignAivoz.tipificaciones.length; i++) {
        let tip = this.globalService.campaignAivoz.tipificaciones[i];
        if (tipificacion._id == tip._id) {
          if (tip.enviarEmail) 
            tipificacion.enviarEmail = false;
          else 
            tipificacion.enviarEmail = true;
          this.globalService.campaignAivoz.tipificaciones[i] = tipificacion;
          break;
        }
      }
      console.log(this.globalService.campaignAivoz);
      this.globalService.campaignAivoz.comando = null;
      await this.api.updateAivozCampaign(this.globalService.campaignAivoz);
      this.utils.openDialog("Tipificación actualizada", tipificacion.enviarEmail ? "Se ha activado envío de email en la tipificación" : "El envío de email de la tipificación se ha desactivado" , false, false);

    
  }

  tipificaciones() {
    return this.globalService.campaignAivoz.tipificaciones;
  }

  objetivos() {
    return this.globalService.campaignAivoz.objetivos;
  }

  mostrarSaludo() {
    if (this.globalService.checkService('saludo')) {
    this.loading = true;
    this.muestraSaludo = true;
    setTimeout(() => {
      let area = (document.getElementById("saludo") as HTMLTextAreaElement);
      area.value = this.globalService.campaignAivoz.saludo;
      this.loading = false;
    }, 500)
  } else {
    this.utils.openDialog('Permisos', 'No tiene permisos de acceso a esta opción', false, true);

  }
    
  }

  private enviarDatos(workbook: any, hoja: any){
    let hojaActual = hoja;
    let XL_row_object = 
    XLSX.utils.sheet_to_json(workbook.Sheets[hoja]);
    let json_object = JSON.stringify(XL_row_object);
    // aqui parseamos a json
    const datos = JSON.parse(json_object);
   
    return XL_row_object;

 }

obtenerDatos(file: any) {
  this.loading = true;
    let workbook = null;
    let hojas = [];
    let reader = new FileReader();
    reader.onload = async (e) => {
      let data = (<any>e.target).result;
      workbook = XLSX.read(data, {
        type: 'binary',  cellDates: true 
      });
      file.value = ''
      let hojas: any = workbook.SheetNames;
      console.log('Hojas: ', hojas);
      let dataXls  = this.enviarDatos(workbook, 'DISCADOR');
      console.log('Data: ', dataXls);
      let bodyDiscador = {
        idCampaign: this.globalService.campaignAivoz.idCampaign,
        idCliente: this.globalService.clienteAivoz._id,
        token: this.globalService.campaignAivoz.netelipToken,
        api: this.globalService.campaignAivoz.api,
        usuarios: dataXls,
        estado: 0
      } 

      let discador = await this.api.uploadDiscador(bodyDiscador);
      this.loading = false;
      console.log('Discador: ', discador);
      this.mostrarDiscador();
      if (discador) {
        this.utils.openDialog('Discador', 'Discador Cargado con ' + discador.usuarios.length + ' usuarios', false, true);
      } else {
        this.utils.openDialog('Discador', 'Error al cargar el Discador', false, true);

      }

    }
   

    reader.onerror = function (ex) {
     //manejar error de carga aqui
    console.log(ex);
    };
    reader.readAsBinaryString(file.files[0]);
  };

  constructor(public utils: UtilityProvider, public dm: DataManagement,  public api:RestWS, public globalService: GlobalService, private router: Router,) { }

  ngOnInit(): void {
    //this.showPass = !this.globalService.Admin;
    if (!this.globalService.clienteAivoz) {
      this.router.navigateByUrl("/pages/auth/login");
    }
  }

}
